import {Component, computed, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Checkbox} from 'primeng/checkbox';
import {HrToolAiCapabilityType, HrToolAiCapabilityView} from '@frontend/shared-api';
import {AiCapabilityLabelComponent} from '../../../../shared/components/ai-capability-label/ai-capability-label.component';
import {countAvailableAiCapabilities} from '../../../../shared/utils/hr-tool-ai-capability.utils';
import {
  AiCapabilityFilterOption,
  AiCapabilitySelectionChange,
} from './hr-tool-ai-capability-filter.types';

@Component({
  selector: 'app-hr-tool-ai-capability-filter',
  imports: [FormsModule, Checkbox, AiCapabilityLabelComponent],
  templateUrl: './hr-tool-ai-capability-filter.component.html',
})
export class HrToolAiCapabilityFilterComponent {
  readonly tools = input<readonly {aiCapabilities?: HrToolAiCapabilityView[]}[]>([]);
  readonly selected = input<readonly HrToolAiCapabilityType[]>([]);

  readonly selectionChange = output<AiCapabilitySelectionChange>();

  protected readonly options = computed<AiCapabilityFilterOption[]>(() => {
    const selected = this.selected();
    return countAvailableAiCapabilities(this.tools()).map(({capability, count}) => ({
      capability,
      count,
      selected: selected.includes(capability),
      rowTestId: `filter-aiCapability-${capability}`,
      countTestId: `filter-aiCapability-count-${capability}`,
      checkboxTestId: `filter-aiCapability-checkbox-${capability}`,
      inputId: `ai-${capability}`,
    }));
  });

  protected toggle(capability: HrToolAiCapabilityType, checked: boolean): void {
    this.selectionChange.emit({capability, checked});
  }
}
